export default __webpack_public_path__ + "static/media/Gjensidige.d232cdae.svg";